export default __webpack_public_path__ + "static/media/ic_collapse.a8451d02.svg";